import {
  createFileRoute,
  useNavigate,
  useRouterState,
} from '@tanstack/react-router';
import {
  useLocationBulkControllerCreateBatch,
  useLocationBulkControllerGetLatestBatch,
} from '@/generated/api/location-bulk.ts';
import { useCallback, useEffect, useRef } from 'react';
import LoaderAppShell from '@/common/components/LoaderAppShell.tsx';

export const Route = createFileRoute('/data/locations/create/')({
  component: RouteComponent,
  staticData: {
    authorization: {
      permission: {
        location: ['write'],
      },
    },
  },
});

function RouteComponent() {
  const navigate = useNavigate();
  const pathname = useRouterState({
    select: (state) => state.location.pathname,
  });
  const handlingBatchRerouteRef = useRef(false);
  const latestBatch = useLocationBulkControllerGetLatestBatch();
  const createBatch = useLocationBulkControllerCreateBatch();

  const getOrCreateBatch = useCallback(async () => {
    if (pathname !== '/data/locations/create') return;
    if (handlingBatchRerouteRef.current) return;
    if (latestBatch.data === undefined) return;

    try {
      handlingBatchRerouteRef.current = true;

      if (latestBatch.data.batch !== null) {
        void navigate({
          replace: true,
          to: '/data/locations/create/$batchId',
          params: { batchId: latestBatch.data.batch.id },
        });
        return;
      }

      const batch = await createBatch.mutateAsync();
      void navigate({
        replace: true,
        to: '/data/locations/create/$batchId',
        params: { batchId: batch.id },
      });
    } catch (error) {
      handlingBatchRerouteRef.current = false;
      throw error;
    }
  }, [pathname, latestBatch.data, createBatch, navigate]);

  useEffect(
    () => void getOrCreateBatch(),
    [getOrCreateBatch, latestBatch.data],
  );

  return <LoaderAppShell text={'Loading batch...'} />;
}
